<template>
  <van-nav-bar
    title="新建工单"
    left-text="返回"
    left-arrow
    fixed
    placeholder
    @click-left="onClickLeft"
  />
  <van-form @submit="onSubmit" scroll-to-error class="form">
    <div class="inner">
      <van-cell-group>
        <van-field readonly v-model="userInfo.name" label="报修人" />
        <!-- 部门 -->
        <van-field
          v-model="state.department.fieldValue"
          readonly
          clickable
          required
          label="部门"
          placeholder="请选择部门"
          :rules="[{ required: true, message: '请选择部门' }]"
          @click="departmentClick"
        />
        <van-popup v-model:show="state.department.show" round position="bottom">
          <van-picker
            :columns="state.department.columns"
            :columns-field-names="{
              text: 'department_name',
            }"
            @cancel="state.department.show = false"
            @confirm="departmentConfirm"
          />
        </van-popup>
        <!-- 部门 end -->
        <!-- 店铺 -->
        <template v-if="isStore">
          <van-field
            required
            label="所属店铺"
            v-model="userInfo.store_name"
            readonly
          />
          <!-- 店铺的位置 -->
          <van-field
            name="place"
            readonly
            v-model="state.storePlace.fieldValue"
            label="店铺位置"
            placeholder="请选择店铺位置"
            @click="state.storePlace.show = true"
            required
            :rules="[{ required: true, message: '请选择店铺位置' }]"
          />
          <van-popup
            v-model:show="state.storePlace.show"
            round
            position="bottom"
          >
            <van-cascader
              v-model="state.storePlace.selected"
              title="请选择店铺位置"
              :options="userInfo.store_place_arr"
              :field-names="{ text: 'place_full_name', value: 'place_id' }"
              @close="state.storePlace.show = false"
              @finish="storePlaceFinish"
            />
          </van-popup>
        </template>

        <!-- 位置 -->
        <van-field
          v-else
          name="place"
          readonly
          v-model="state.place.fieldValue"
          label="位置"
          placeholder="请选择位置"
          @click="state.place.show = true"
          required
          :rules="[{ required: true, message: '请选择位置' }]"
        />
        <place v-model:show="state.place.show" second @confirm="placeConfirm" />
        <!-- 位置 end -->
        <!-- 设备 -->
        <van-field
          v-if="
            power('1-2-3') &&
            (state.place.fieldValue || state.storePlace.fieldValue)
          "
          v-model="state.device.fieldValue"
          readonly
          clickable
          label="设备"
          placeholder="请选择设备"
          @click="state.device.show = true"
        />
        <van-action-sheet
          v-model:show="state.device.show"
          :actions="state.device.actions"
          cancel-text="取消选择"
          close-on-click-action
          @select="deviceSelect"
          @cancel="deviceCancel"
        />
        <!-- 设备end -->
      </van-cell-group>
      <van-cell-group style="margin-top: 10px" v-if="!power('1-2-5')">
        <!-- 故障类型 -->
        <template
          v-for="(faultType, index) in state.faultType"
          :key="faultType.id"
        >
          <van-field
            :name="'faultType' + index"
            v-model="faultType.fieldValue"
            readonly
            clickable
            required
            label="故障类型"
            placeholder="请选择故障类型"
            :rules="[{ required: true, message: '请选择故障类型' }]"
            @click="faultType.show = true"
          >
          </van-field>
          <div @click.stop class="fault-type">
            <van-stepper
              style="margin-right: 30px"
              v-model="faultType.sum"
              input-width="20"
              button-size="25"
              integer
            />
            <van-button
              round
              size="mini"
              icon="plus"
              type="primary"
              style="margin-right: 10px"
              @click="addFaultType"
            />
            <van-button
              round
              :disabled="state.faultType.length === 1"
              size="mini"
              icon="minus"
              type="primary"
              @click="removeFaultType(index)"
            />
          </div>

          <van-popup v-model:show="faultType.show" round position="bottom">
            <van-picker
              :columns="state.faultTypeColumns"
              :columns-field-names="{
                text: 'faulttype_name',
                children: 'sub_list',
              }"
              @cancel="faultType.show = false"
              @confirm="faultTypeConfirm($event, faultType)"
            />
          </van-popup>
        </template>
      </van-cell-group>

      <van-cell-group style="margin-top: 10px">
        <!-- 目标分组 -->
        <van-field
          v-if="power('1-2-1')"
          name="major"
          v-model="state.major.fieldValue"
          readonly
          clickable
          label="目标分组"
          placeholder="请选择目标分组"
          @click="state.major.show = true"
        />
        <van-popup v-model:show="state.major.show" round position="bottom">
          <van-picker
            :columns="state.major.columns"
            :columns-field-names="{
              text: 'major_name',
            }"
            @cancel="state.major.show = false"
            @confirm="majorConfirm"
          />
        </van-popup>
        <!-- 目标分组 end -->
        <!-- 原因 -->
        <van-field
          name="faultNote"
          v-model="state.faultNote"
          rows="4"
          autosize
          label="报修内容"
          type="textarea"
          maxlength="200"
          placeholder="请描述报修内容"
          show-word-limit
          :required="!power('1-2-7')"
          :rules="[{ required: !power('1-2-7'), message: '请描述报修内容' }]"
        />
        <!-- 原因 end -->
        <!-- 维护等级 -->
        <van-field label="维护等级">
          <template #input>
            <van-radio-group v-model="state.level" direction="horizontal">
              <van-radio name="1">日常</van-radio>
              <van-radio name="2">一般</van-radio>
              <van-radio name="3">紧急</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!-- 维护等级 end -->
        <!-- 预约时间 -->
        <van-field
          v-model="state.appointmentTime.fieldValue"
          readonly
          clickable
          label="预约时间"
          placeholder="选择预约时间"
          @click="state.appointmentTime.show = true"
        />
        <van-popup v-model:show="state.appointmentTime.show" position="bottom">
          <van-datetime-picker
            v-model="state.appointmentTime.value"
            type="datetime"
            title="选择完整时间"
            :min-date="state.appointmentTime.minDate"
            @confirm="appointmentTimeConfirm"
            @cancel="state.appointmentTime.show = false"
          />
        </van-popup>
        <!-- 预约时间 end -->
        <!-- 回访电话 -->
        <van-field
          v-model="state.mobile"
          label="回访电话"
          placeholder="请输入回访电话"
        />
        <!-- 回访电话 end -->
      </van-cell-group>
      <!-- 现场图片 -->
      <van-field label="现场图片">
        <template #input>
          <van-uploader
            v-model="state.upload.fileList"
            :max-count="6"
            :after-read="upload"
          />
        </template>
      </van-field>
      <!-- 现场图片 end -->
      <!-- 备注 -->
      <van-field
        v-model="state.note"
        rows="4"
        autosize
        label="备注信息"
        type="textarea"
        maxlength="200"
        placeholder="请输入备注信息"
        show-word-limit
      />
      <!-- 备注 end -->

      <!-- 特殊工单 -->
      <van-field
        v-if="power('1-2-4')"
        name="collection"
        v-model="state.collection.fieldValue"
        readonly
        clickable
        required
        label="特殊工单"
        placeholder="请选择特殊工单"
        :rules="[{ required: true, message: '请选择特殊工单' }]"
        @click="state.collection.show = true"
      />
      <van-popup v-model:show="state.collection.show" round position="bottom">
        <van-picker
          :columns="state.collection.columns"
          :columns-field-names="{
            text: 'collection_name',
          }"
          @cancel="state.collection.show = false"
          @confirm="collectionConfirm"
        />
      </van-popup>
      <!-- 特殊工单 end -->
    </div>
    <div style="background: #fff; padding: 16px">
      <van-button round block type="primary" native-type="submit">
        提交
      </van-button>
    </div>
  </van-form>
</template>
<script>
import { computed, reactive } from "vue";
import { useRouter } from "vue-router";
import { repairService, deviceService, baseService } from "@/service";
import { useStore } from "@/store";
import { whenever } from "@vueuse/core";
import { Toast } from "vant";
import moment from "moment";
import { usePower } from "@/hooks";
export default {
  name: "Create",
  setup() {
    const store = useStore();
    const router = useRouter();

    const onClickLeft = () => {
      router.push({
        name: "Index",
      });
    };
    const userInfo = computed(() => store.state.userInfo);
    const isStore = computed(() => Boolean(userInfo.value.store_id));
    const { power } = usePower();
    // form
    const state = reactive({
      department: {
        show: false,
        value: userInfo.value.department_id,
        fieldValue: userInfo.value.department_name,
        columns: [],
      },
      place: {
        show: false,
        fieldValue: "",
        selected: [],
      },
      storePlace: {
        show: false,
        fieldValue: "",
        selected: "",
      },
      device: {
        show: false,
        value: "",
        fieldValue: "",
        actions: [],
      },
      faultType: [],
      faultTypeColumns: [],
      faultNote: "",
      note: "",
      level: "1",
      appointmentTime: {
        show: false,
        value: moment().toDate(),
        fieldValue: moment().format("YYYY-MM-DD HH:mm"),
        timestamp: moment().format("X"),
        minDate: moment().toDate(),
      },
      mobile: userInfo.value.mobile_number,
      upload: {
        fileList: [],
      },
      collection: {
        show: false,
        value: "",
        fieldValue: "",
        columns: [],
      },
      major: {
        show: false,
        value: "",
        fieldValue: "通知全部",
        columns: [],
      },
    });
    // 部门
    const getDepartmentList = async () => {
      const { data } = await baseService.departmentList();
      state.department.columns = data;
    };
    getDepartmentList();

    const departmentConfirm = (value) => {
      state.department.fieldValue = value.department_name;
      state.department.value = value.id;
      state.department.show = false;
    };
    const departmentClick = () => {
      if (!power("1-2-2")) {
        Toast.fail("无权限修改");
        return;
      }
      state.department.show = true;
    };
    // 店铺
    if (userInfo.value.store_place_arr.length === 1) {
      const { place_full_name, place_id } = userInfo.value.store_place_arr[0];
      state.storePlace.fieldValue = place_full_name;
      state.storePlace.selected = place_id;
    }
    // 店铺位置
    const storePlaceFinish = ({ selectedOptions }) => {
      state.storePlace.show = false;
      state.storePlace.fieldValue = selectedOptions[0].place_full_name;
    };
    // 位置
    const placeConfirm = (value) => {
      state.place.fieldValue = value.fieldValue;
      state.place.selected = value.selected;
    };
    // 设备
    const getDeviceList = async () => {
      try {
        const { data } = await deviceService.deviceList({
          place_id: isStore.value
            ? state.storePlace.selected
            : state.place.selected[1].id,
        });
        state.device.actions = data.map((item) => ({
          name: item.device_name,
          id: item.id,
        }));
      } catch (error) {
        state.device.actions = [];
      }
    };
    const deviceSelect = (value) => {
      state.device.fieldValue = value.name;
      state.device.value = value.id;
    };
    const deviceCancel = () => {
      state.device.fieldValue = "";
      state.device.value = "";
    };
    whenever(
      () => state.place.fieldValue || state.storePlace.selected,
      () => {
        getDeviceList();
        deviceCancel();
      }
    );
    // 设备end

    // 类型
    const getFaultTypeList = async () => {
      const { data } = await baseService.faultTypeList();
      state.faultTypeColumns = data;
    };
    getFaultTypeList();
    const faultTypeConfirm = (option, faultType) => {
      faultType.fieldValue = option[1].faulttype_full_name;
      faultType.value = option[1].id;
      faultType.pid = option[1].pid;
      faultType.show = false;
    };
    const addFaultType = () => {
      state.faultType.push({
        id: moment().format("X"),
        show: false,
        value: "",
        pid: "",
        fieldValue: "",
        sum: 1,
      });
    };
    if (!power("1-2-5")) {
      addFaultType();
    }

    const removeFaultType = (index) => {
      state.faultType.splice(index, 1);
    };
    // 设备类型end
    // 预约时间
    const appointmentTimeConfirm = (date) => {
      state.appointmentTime.fieldValue =
        moment(date).format("YYYY-MM-DD HH:mm");
      state.appointmentTime.timestamp = moment(date).format("X");
      state.appointmentTime.show = false;
    };
    // 文件上传
    const upload = async (file) => {
      try {
        file.status = "uploading";
        file.message = "上传中...";
        const data = await baseService.upload(file.file);
        file.status = "done";
        file.message = "上传成功";
        file.file_ids = data.file_ids;
      } catch (error) {
        file.status = "failed";
        file.message = "上传失败";
      }
    };
    // 特殊工单
    const getCollectionList = async () => {
      const { data } = await baseService.collectionList();
      state.collection.columns = data;
      const find = state.collection.columns.find((column) => column.id === "1");
      if (find && power("1-2-4")) {
        state.collection.value = find.id;
        state.collection.fieldValue = find.collection_name;
      }
    };
    getCollectionList();
    const collectionConfirm = (option) => {
      state.collection.fieldValue = option.collection_name;
      state.collection.value = option.id;
      state.collection.show = false;
    };
    // 目标分组
    const getMajorList = async () => {
      const { data } = await repairService.dispatchMajorList();
      state.major.columns = [
        {
          major_name: "通知全部",
          id: "",
        },
        ...data,
      ];
    };
    getMajorList();
    const majorConfirm = (option) => {
      state.major.fieldValue = option.major_name;
      state.major.value = option.id;
      state.major.show = false;
    };
    // 提交
    const onSubmit = async () => {
      await repairService.addFault({
        store_id: userInfo.value.store_id || "",
        fault_name: userInfo.value.name,
        fault_uid: userInfo.value.id,
        department_id: userInfo.value.department_id,
        region_id: isStore.value ? "" : state.place.selected[0].id,
        fault_note: state.faultNote,
        note: state.note,
        rlevel: state.level,
        fault_mobile_number: state.mobile,
        place_id: isStore.value
          ? state.storePlace.selected
          : state.place.selected[1].id,
        appointment_time: state.appointmentTime.timestamp,
        device_id: state.device.value,
        fault_file_ids: state.upload.fileList
          .map((file) => file.file_ids)
          .join(),
        collection_id: state.collection.value,
        target_major_id: state.major.value,
        faulttype_info: JSON.stringify(
          state.faultType.map((item) => ({
            faulttype_id: item.value,
            faulttype_sum: item.sum,
            faulttype_type_id: item.pid,
          }))
        ),
      });
      Toast.success("新建工单成功");
      router.push({
        name: "Index",
      });
    };
    return {
      userInfo,
      onClickLeft,
      state,
      departmentConfirm,
      departmentClick,
      placeConfirm,
      deviceSelect,
      deviceCancel,
      faultTypeConfirm,
      appointmentTimeConfirm,
      upload,
      collectionConfirm,
      onSubmit,
      addFaultType,
      removeFaultType,
      majorConfirm,
      power,
      storePlaceFinish,
      isStore,
    };
  },
};
</script>
<style lang="less" scoped>
.form {
  display: flex;
  height: calc(100vh - 46px);
  flex-direction: column;
  justify-content: space-between;
  .inner {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }
}
.fault-type {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
